import PageHeader from "app/shared/PageHeader";
import "./Flights2B.scss";
import CustomReconTabs from "../Reconcilation/components/CustomReconTabs";
import { useEffect, useState } from "react";
import { useRecoilState } from "recoil";
import { tabViewStates, userInfo } from "app/config/States/users";

import { Button, Modal, Tabs, Tag } from "antd";

import {
  API_ENDPOINT_FETCH_AIRLINE_CREDENTIALS_LIST,
  API_ENDPOINT_FETCH_CLUSTOR_EMAIL_LIST,
  API_ENDPOINT_FETCH_EMAIL_CREDENTIALS_LIST,
  API_ENDPOINT_FETCH_GST_CREDENTIALS_LIST,
} from "../Credentials/credentials.constants";
import { apiGet } from "app/services/apiServices";

import Loader from "app/shared/Loader";
import FlightDashboard from "./components/FlightDashboard";
import FlightRecon from "./components/FlightRecon";
import FlightReports from "./components/FlightReports";
import UnReconciledFlight from "../AppTour/components/OnboardUnReconcilied/UnReconciledFlight";
export default function Flights2B(props: any) {
  const [activeTab, setActiveTab] = useState("1");
  const [userDetails, _] = useRecoilState<any>(userInfo);
  const items = [
    {
      key: "1",
      label: "Dashboard",
    },
    // {
    //   key: "2",
    //   label: "Reconciliation",
    // },
    {
      key: "3",
      label: "Reports",
    },
    {
      key: "4",
      label: "Booking Data",
    },
  ];

  const renderScene = () => {
    switch (activeTab) {
      case "1":
        return <FlightDashboard />;
      case "2":
        return <FlightRecon />;
      case "3":
        return <FlightReports />;
      case "4":
        return (
          <UnReconciledFlight
            singleWorkspace={
              userDetails?.currentWorkspace?.name == "MMT Admin" ? false : true
            }
          />
        );
      default:
        return <FlightDashboard />;
    }
  };

  return (
    <div className="Flights">
      <div className="ScreenContainer">
        <PageHeader
          leftActions={
            <Tabs
              items={items}
              tabBarStyle={{
                borderBottom: "none",
                margin: 0, // Remove the underline border
              }}
              activeKey={activeTab}
              onChange={(tabItem: string) => setActiveTab(tabItem)}
            />
          }
        />

        <div className="TableContainer">{renderScene()}</div>
      </div>
    </div>
  );
}
